import { useSearchParams } from 'react-router-dom';

export const useRelevantQueryParams = (exclude: string[] = []) => {
    const [searchParams] = useSearchParams();
    const params: Record<string, string> = {};
    searchParams.forEach((value, key) => {
        if (!['All', ...exclude].includes(key)) {
            params[key] = value;
        }
    });
    return params;
};
